import React from 'react';
export function PrivacyContent() {
  return <div className="space-y-5 font-sans text-foreground/75 text-sm md:text-base leading-relaxed" data-id="element-131">
      <p className="text-foreground/50 text-xs uppercase tracking-widest" data-id="element-132">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long'
      })}
      </p>

      <section data-id="element-133">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-134">
          1. Información que recopilamos
        </h4>
        <p data-id="element-135">
          Cuando adquieres El Código de la Sombra, recopilamos únicamente la
          información necesaria para procesar tu compra: nombre, correo
          electrónico y datos de facturación. No almacenamos información de
          tarjetas de crédito; los pagos son procesados por proveedores externos
          certificados.
        </p>
      </section>

      <section data-id="element-136">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-137">
          2. Uso de la información
        </h4>
        <p data-id="element-138">
          Tu información se utiliza exclusivamente para entregar el producto
          digital, enviarte el acceso al PDF y proporcionar soporte relacionado
          con tu compra. No vendemos, alquilamos ni compartimos tus datos con
          terceros con fines comerciales.
        </p>
      </section>

      <section data-id="element-139">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-140">
          3. Cookies y seguimiento
        </h4>
        <p data-id="element-141">
          Este sitio utiliza cookies y tecnologías de seguimiento (incluyendo
          píxeles de publicidad) para medir el rendimiento de la página y
          optimizar la experiencia. Puedes desactivarlas desde la configuración
          de tu navegador en cualquier momento.
        </p>
      </section>

      <section data-id="element-142">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-143">
          4. Tus derechos
        </h4>
        <p data-id="element-144">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Las solicitudes se procesarán dentro de los 30
          días hábiles siguientes a su recepción.
        </p>
      </section>

      <section data-id="element-145">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-146">
          5. Seguridad
        </h4>
        <p data-id="element-147">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información contra accesos no autorizados, pérdida o
          alteración. Sin embargo, ninguna transmisión por Internet es 100%
          segura.
        </p>
      </section>

      <section data-id="element-148">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-149">
          6. Cambios en esta política
        </h4>
        <p data-id="element-150">
          Nos reservamos el derecho de modificar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta misma página
          con la fecha de la última actualización.
        </p>
      </section>
    </div>;
}
export function TermsContent() {
  return <div className="space-y-5 font-sans text-foreground/75 text-sm md:text-base leading-relaxed" data-id="element-151">
      <p className="text-foreground/50 text-xs uppercase tracking-widest" data-id="element-152">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long'
      })}
      </p>

      <section data-id="element-153">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-154">
          1. Aceptación de los términos
        </h4>
        <p data-id="element-155">
          Al adquirir El Código de la Sombra, aceptas estos términos de uso en
          su totalidad. Si no estás de acuerdo con alguno de estos términos, no
          realices la compra.
        </p>
      </section>

      <section data-id="element-156">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-157">
          2. Naturaleza del producto
        </h4>
        <p data-id="element-158">
          El Código de la Sombra es un producto digital de carácter educativo e
          informativo. La información presentada está basada en investigación
          filosófica, psicológica y social, y debe ser entendida como material
          de referencia, no como consejo profesional, terapéutico o legal.
        </p>
      </section>

      <section data-id="element-159">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-160">
          3. Uso ético
        </h4>
        <p data-id="element-161">
          El contenido de este producto está diseñado para defensa personal,
          autoconocimiento y desarrollo estratégico. El comprador se compromete
          a no utilizar la información para causar daño deliberado, manipular
          emocionalmente con malicia, ni cometer actos ilegales contra otras
          personas.
        </p>
      </section>

      <section data-id="element-162">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-163">
          4. Propiedad intelectual
        </h4>
        <p data-id="element-164">
          Todo el contenido (texto, marco metodológico, hojas de trabajo y
          materiales descargables) está protegido por derechos de autor. Está
          prohibida la redistribución, reventa, copia o transmisión del material
          a terceros sin autorización expresa por escrito.
        </p>
      </section>

      <section data-id="element-165">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-166">
          5. Política de reembolso
        </h4>
        <p data-id="element-167">
          Debido a la naturaleza digital del producto y al acceso inmediato al
          contenido completo tras la compra, todas las ventas son finales. No se
          procesan reembolsos una vez entregado el archivo PDF.
        </p>
      </section>

      <section data-id="element-168">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-169">
          6. Limitación de responsabilidad
        </h4>
        <p data-id="element-170">
          Los resultados descritos en esta página son ilustrativos. El éxito en
          la aplicación del método depende del esfuerzo, contexto y dedicación
          de cada lector. No garantizamos resultados específicos y no nos
          hacemos responsables de las decisiones tomadas a partir del contenido.
        </p>
      </section>

      <section data-id="element-171">
        <h4 className="font-serif text-lg font-bold text-foreground mb-2" data-id="element-172">
          7. Modificaciones
        </h4>
        <p data-id="element-173">
          Nos reservamos el derecho de actualizar o modificar estos términos en
          cualquier momento. La versión vigente será siempre la publicada en
          esta página.
        </p>
      </section>
    </div>;
}